<mat-card>
  <mat-card-title>Generar Anexos Masivos</mat-card-title>

  <mat-stepper linear #stepper>

    <!-- Paso 1: Seleccionar Trabajadores -->
    <mat-step label="Seleccionar Trabajadores">
      <mat-form-field appearance="outline">
        <mat-label>Filtrar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar trabajador, empresa, cargo, etc.">
      </mat-form-field> 
      
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        
        <!-- Checkbox de selección -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox [checked]="isAllSelected()" (change)="toggleAllRows($event.checked)">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (change)="toggleSelection(row)" [checked]="selectedRows.has(row)">
            </mat-checkbox>
          </td>
        </ng-container>
      
        <!-- Nombre Trabajador -->
        <ng-container matColumnDef="nombreTrabajador">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Trabajador</th>
          <td mat-cell *matCellDef="let row">{{ row.nombreTrabajador }}</td>
        </ng-container>
      
        <!-- Empresa -->
        <ng-container matColumnDef="empresa">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Empresa</th>
          <td mat-cell *matCellDef="let row">{{ row.empresa }}</td>
        </ng-container>
      
        <!-- Cargo -->
        <ng-container matColumnDef="cargo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Cargo</th>
          <td mat-cell *matCellDef="let row">{{ row.cargo }}</td>
        </ng-container>
      
        <!-- Fecha de término -->
        <ng-container matColumnDef="fechaTermino">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha de Término</th>
          <td mat-cell *matCellDef="let row">{{ row.fechaTermino | date:'dd/MM/yyyy' }}</td>
        </ng-container>
      
        <!-- Días restantes -->
        <ng-container matColumnDef="diffDays">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Días Restantes</th>
          <td mat-cell *matCellDef="let row">{{ row.diffDays }}</td>
        </ng-container>
      
        <ng-container matColumnDef="tipo_contrato">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo de Documento</th>
          <td mat-cell *matCellDef="let row">{{ row.tipo_contrato === 1 ? 'Contrato' : 'Anexo' }}</td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        [ngClass]="{'vencido': row.diffDays < 0, 'proximo-vencer': row.diffDays <= 5 && row.diffDays >= 0}">
    </tr>
      </table>
      
      <mat-paginator [pageSizeOptions]="[20, 40, 60]" [pageSize]="20" showFirstLastButtons></mat-paginator>
      
      <button mat-button matStepperNext [disabled]="selectedRows.size === 0">Siguiente</button>
      
    </mat-step>

    <!-- Paso 2: Seleccionar Cláusula -->
    <mat-step label="Seleccionar Cláusula">
      <mat-form-field appearance="outline" style="width: 45%; margin-right: 70px;">
        <mat-label>Fecha Firma Anexo</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          [(ngModel)]="fechaFirmaAnexo"
          name="fechaFirmaAnexo"
          required
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker touchUi #picker></mat-datepicker>
      </mat-form-field>
      
        
        <mat-form-field appearance="outline" style="width: 45%;">
          <mat-label>Ciudad en que se firma anexo</mat-label>
          <mat-select [(ngModel)]="CiudadSeleccionada">
            <mat-option *ngFor="let ciudad of lista_ciudades" [value]="ciudad">
              {{ ciudad.nombre }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      
      <div class="form-row">
        <div class="form-group col-md-5">
          <h4 style="color:#2a3f54"><b>NÚMERO ORIGINAL DE LA CLÁUSULA</b></h4>
          <input style="width: 100%;" [(ngModel)]="numero_clausula"
            (ngModelChange)="numero_clausula = $event.toUpperCase()" type="text" pInputText (change)="ObtenerClausula()" />
        </div>
        <div class="form-group col-md-1">
          <br />
          <br />
          <p-button (click)="MostrarEjemplo()" icon="pi pi-eye"></p-button>
        </div>
        <div class="form-group col-md-6">
          <h4 style="color:#2a3f54"><b>CLÁUSULA A MODIFICAR</b></h4>
          <p-dropdown [(ngModel)]="clausula_seleccionada" [showClear]="true" [options]="clausulas" [filter]="true"
            [scrollHeight]="400" [style]="{ width: '100%' }" (onChange)="ObtenerClausula($event)" filterBy="nombre"
            placeholder="Seleccione cláusula" optionLabel="nombre"></p-dropdown>
        </div>
      </div>
      <div *ngIf="mostrarfecha == true">
        <div class="form-group row">
          <div class="col-3">
            <h4 style="color:#2a3f54"><b>3 Meses</b></h4>
            <p-inputSwitch [(ngModel)]="TresMeses" (click)="obtener_fecha_clausula(click3Meses())" class="myInput"></p-inputSwitch>
          </div>
          <div class="col-3">
            <h4 style="color:#2a3f54"><b>6 Meses</b></h4>
            <p-inputSwitch [(ngModel)]="SeisMeses" (click)=" obtener_fecha_clausula(click6Meses())"
              class="myInput"></p-inputSwitch>
          </div>
          <div class="col-3">
            <h4 style="color:#2a3f54"><b>Indefinido</b></h4>
            <p-inputSwitch [(ngModel)]="indefinido" (click)="clickIndefinido()" class="myInput"></p-inputSwitch>
          </div>
          <div class="col-3">
            <h4 style="color:#2a3f54"><b>Otro</b></h4>
            <p-inputSwitch [(ngModel)]="Otro" (click)="clickOtro()"
              class="myInput"></p-inputSwitch>
          </div>

          <div class="form-group col-md-12" *ngIf=" Otro == true">
            <h4 style="color:#2a3f54"><b>FECHA TERMINO </b></h4>
            <p-calendar dateFormat="dd/mm/yy" showIcon="true" placeholder="Ingrese fecha" [style]="{ width: '100%' }"
              (onSelect)="obtener_fecha_clausula($event)"></p-calendar>
          </div>

        </div>
      </div>
      <br />
      <br />
      <div class="form-group col-md-12">
        <textarea [(ngModel)]="texto" [rows]="20" [cols]="20" style="width:100%;" pInputTextarea>
        </textarea>
      </div>
      <button mat-button matStepperPrevious>Anterior</button>
      <button mat-button matStepperNext [disabled]="!clausula_seleccionada">Siguiente</button>
    </mat-step>

    <!-- Paso 3: Generar Anexos -->
    <mat-step label="Generar Anexos">
      <p>Se generarán anexos para {{ selectedRows.size }} trabajadores con la cláusula seleccionada.</p>

      <button mat-button matStepperPrevious>Anterior</button>
      <button mat-raised-button color="primary" (click)="generarAnexosMasivos()">Generar Anexos</button>
    </mat-step>

  </mat-stepper>
  <p-dialog [(visible)]="ejemplo" [modal]="true" [style]="{ width: '75%' }" [draggable]="false" [resizable]="false">
    <div id="itemsContrato">
      <div class="col-md-12">
        <br />
        <h4 style="color:#2a3f54"><b>ITEMS COMUNES DE UN CONTRATO</b></h4>
      </div>
      <ul style="list-style:none">
        <li>
          <h6 style="color:#49505c;">I. Partes</h6>
        </li>
        <li>
          <h6 style="color:#49505c;">II. Naturaleza de los servicios</h6>
        </li>
        <li>
          <h6 style="color:#49505c;">III. Lugar de la prestación de servicios</h6>
        </li>
        <li>
          <h6 style="color:#49505c;">IV. Jornada de trabajo</h6>
        </li>
        <li>
          <h6 style="color:#49505c;">V. Remuneraciones</h6>
        </li>
        <li>
          <h6 style="color:#49505c;">
            VI. Duración de la relación jurídica laboral
          </h6>
        </li>
        <li>
          <h6 style="color:#49505c;">VII. Cláusula de la vigencia</h6>
        </li>
        <li>
          <h6 style="color:#49505c;">VIII. A tener en cuenta</h6>
        </li>
      </ul>
    </div>
    <ng-template pTemplate="footer">
      <p-button icon="pi pi-check" (click)="ejemplo = false" label="Ok" styleClass="p-button-text"></p-button>
    </ng-template>
  </p-dialog>
</mat-card>
